import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getFirebaseStorage } from './firebase';

const STORAGE_PREFIX = 'alert_sounds';
const MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

function sanitizeFileName(name: string): string {
  return name.replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 120);
}

export async function uploadAlertSound(file: File): Promise<string> {
  if (!file.type.startsWith('audio/')) {
    throw new Error('Please upload an audio file.');
  }
  if (file.size > MAX_SIZE_BYTES) {
    throw new Error('Audio file must be under 10MB.');
  }

  const storage = getFirebaseStorage();
  const ext = file.name.includes('.') ? file.name.slice(file.name.lastIndexOf('.')) : '';
  const baseName = sanitizeFileName(file.name.replace(/\.[^.]+$/, '') || 'kitchen-alert');
  const fileName = `${Date.now()}-${baseName}${ext}`;
  const path = `${STORAGE_PREFIX}/${fileName}`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, file, { contentType: file.type });
  return getDownloadURL(storageRef);
}

